import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@ui/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@ui/components/ui/dialog';

interface RemoveMemberDialogProps {
  open: boolean;
  name: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Removal is permanent and says so. There is no undo beyond adding the person again. */
const RemoveMemberDialog = ({ open, name, isPending, onCancel, onConfirm }: RemoveMemberDialogProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('removeMember.title')}</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-foreground">{t('removeMember.body', { name })}</p>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel} disabled={isPending}>
            {t('actions.cancel')}
          </Button>
          <Button type="button" onClick={onConfirm} disabled={isPending}>
            {t('removeMember.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RemoveMemberDialog;
